/*
 *   File : risk-profiling.js.js
 *   Author : https://evoqins.com
 *   Description : User Risk score creating page
 *   Integrations : 
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// Components
import { Step1 } from './index';
import { Loader } from '../../Component/Others';
import { APIService } from '../../Service';
import { _scrollToTop } from '../../Helper';

function RiskProfiling(props) {

    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [riskQuestions, setRiskQuestions] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        setDataLoading(true);
        _getRiskProfile();
    }, []);

    // handle update step
    const _handleUpdateStep = (step) => {
        setCurrentStep(step);
        // Scroll the page to top
        _scrollToTop();
    };

    // handle Back
    const _handleBack = () => {
        if (currentStep === 1) {
            navigate("summary")
        } else {
            setCurrentStep(currentStep - 1);
        }
    };


    // ================================================== //
    // ============ RISK PROFILE API CALLS ============== //
    const _getRiskProfile = async () => {
        let url = "profile/get-questions";
        let data = {
            "tenant_id": props.tenantID
        };
        const response = await APIService(url, data);

        if (response.status_code === 200) {
            setRiskQuestions(response.data);
        } else {
            toast.dismiss();
            toast.error("Something went wrong please try again after some time");
            navigate(-1);
        }
        setDataLoading(false);
    };

    return (
        dataLoading ?
            <Loader wrapperClassName="h-100 margin-100px-top w-100" />
            :
            <div className='mb-5'>

                <Step1 questions={riskQuestions}
                    // riskHistoryData={props.riskHistory}
                    userID={props.userID}
                    tenantID={props.tenantID}
                    basketName={props.basketName}
                    basketRiskInfo={props.basketRiskInfo}
                    handleUpdateStep={_handleUpdateStep}
                    handleOnSuccess={props.handleOnSuccess} />

                {/* 
                    <div className={`${Styles.e_banner_wrapper} border-radius-16 px-3 px-sm-4 padding-32px-top e-padding-16px-top-res pb-3 mb-4`}>
                        <TextButton name="Risk Profile"
                            icon={true}
                            className="mb-sm-4 mb-3"
                            textClassName="e-text-white e-font-16-res"
                            icon_color={Colors.white}
                            type={2}
                            onPress={_handleBack} />
                        <div className="e-text-magnolia e-alt-font-lato e-font-weight-400 e-font-14 line-height-18px">
                            STEP {currentStep} OF 3
                            <div className={`${Styles.progress_wrapper} d-flex gap-1 margin-10px-top`}>
                                <span className={`${currentStep >= 1 ? Styles.step_filled : Styles.step_unfilled}`}></span>
                                <span className={`${currentStep >= 2 ? Styles.step_filled : Styles.step_unfilled}`}></span>
                                <span className={`${currentStep >= 3 ? Styles.step_filled : Styles.step_unfilled}`}></span>
                            </div>
                        </div>
                    </div>
                    {currentStep == 1 && <Step1 handleUpdateStep={_handleUpdateStep} questions={riskQuestions} handleOnSuccess={props.handleOnSuccess} />}
                    {currentStep == 2 && <Step2 handleUpdateStep={_handleUpdateStep} />}
                    {currentStep == 3 && <Step3 handleUpdateStep={_handleUpdateStep} handleOnSuccess={props.handleOnSuccess} />}
                */}

            </div>
    )
}

export default RiskProfiling;